import { getStorage } from "@/utils/storage";
import { calcDateNum } from '@/utils/baseDate'

const _t = getStorage('home_to_login_tip_visible_close_time')
const timeFlag = !_t ? true : calcDateNum(_t, new Date().getTime()) > 8

export default {
  // 登录状态
  userAccountStatus: true, // 是否已登录12306账户 首页校验接口用
  homeLoginTipVisible: timeFlag,
  userAccountList: [], // 历史登录的12306账户
  accountChannel: 'app',
  changeUserStatus: false,
  code: "0",
  data: null,
  retrievalCode: "",
  faceVerificaStatus: true,
  capResult: null,
  request_id: "",
  userInfo12306: getStorage("userInfo12306") || "",
  accountInfo12306: getStorage("accountInfo12306") || "", // 修改密码的信息
  fullPath: getStorage("backPageUrl") || "",
  isSmsCode: getStorage("isSmsCode") || "",
  is12306Login: getStorage("12306_login_status_for_contacts_page") || 0,
  reverseData: null,
  cxvipPopupShow: false,
  cxvipPopupCloseCb: null,
  cxvipVerify: false,
  showLoginDrawer: false, // 集登陆大成的弹窗   填单登录弹窗
  userPendingRequest: null
};
